import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function FeaturedCategories() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精品分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大品类，每件皆为匠心之作
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg cursor-pointer"
              data-product-shop
            >
              <div className="aspect-[4/3] w-full">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-lg md:text-xl font-heading font-semibold text-background-50 mb-1">
                  {cat.name}
                </h3>
                <p className="text-sm text-background-50/70 line-clamp-2 mb-2">{cat.description}</p>
                <span className="text-xs text-primary-300 font-medium">
                  {cat.productCount} 件精品
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}